import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useSignal } from '@preact/signals';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Await, useLoaderData } from 'react-router';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@etchteam/diamond-ui/composition/Enter/Enter';
import '@/components/composition/Layout/Layout';
import '@/components/composition/Header/Header';
import '@/components/content/Logo/Logo';
import '@/components/content/Icon/Icon';
import '@/components/canvas/Tip/Tip';
import '@/components/composition/Wrap/Wrap';
import Footer from '@/components/content/Footer/Footer';
import TipContent from '@/components/template/TipContent/TipContent';
import { useAppState } from '@/lib/AppState';
import i18n from '@/lib/i18n';
import useAnalytics from '@/lib/useAnalytics';
function About() {
    const { t } = useTranslation();
    return (_jsx("locator-wrap", { children: _jsx("diamond-section", { padding: "lg", children: _jsxs("diamond-enter", { type: "fade", children: [_jsx("h2", { children: t('about.title') }), _jsx("p", { children: t('about.intro') }), _jsx("h3", { className: "diamond-spacing-top-md", children: t('about.becomeAPartner.title') }), _jsx("p", { children: t('about.becomeAPartner.description') }), _jsx("diamond-button", { width: "full-width", children: _jsx("a", { href: t('about.becomeAPartner.url'), target: "_blank", rel: "noopener noreferrer", children: t('about.becomeAPartner.cta') }) }), _jsx("h3", { className: "diamond-spacing-top-md", children: t('about.feedback.title') }), _jsx("p", { children: t('about.feedback.description') }), _jsx("diamond-button", { width: "full-width", children: _jsx("a", { href: t('about.feedback.url'), target: "_blank", rel: "noopener noreferrer", children: t('about.feedback.cta') }) }), _jsx("hr", { className: "diamond-spacing-bottom-md diamond-spacing-top-lg" }), _jsx(Footer, {})] }) }) }));
}
export function DefaultTip() {
    const { publicPath } = useAppState();
    const generalTipImgSrc = `${publicPath}images/general-tip.svg`;
    return (_jsx("locator-tip", { type: "image", children: _jsx("locator-wrap", { children: _jsx("img", { src: generalTipImgSrc, alt: "" }) }) }));
}
export function LoadingTip() {
    return (_jsx("locator-tip", { children: _jsx("locator-wrap", {}) }));
}
export function DefaultAside() {
    const loaderData = useLoaderData();
    const tipPromise = loaderData?.tip;
    return (_jsx("div", { slot: "layout-aside", className: "display-contents", children: _jsx(Suspense, { fallback: _jsx(LoadingTip, {}), children: _jsx(Await, { resolve: tipPromise, children: (tip) => tip ? (_jsx("locator-tip", { slot: "layout-aside", type: "promo", "text-align": "center", children: _jsx("locator-wrap", { children: _jsx(TipContent, { tip: tip }) }) })) : (_jsx(DefaultTip, {})) }) }) }));
}
export default function StartLayout({ children, aside, }) {
    const { t } = useTranslation();
    const { recordEvent } = useAnalytics();
    const locale = i18n.language;
    const open = useSignal(false);
    open.subscribe((value) => {
        if (value === true) {
            recordEvent({
                category: 'About',
                action: 'Open',
            });
        }
    });
    return (_jsxs("locator-layout", { children: [_jsx("locator-header", { slot: "layout-header", children: _jsxs("locator-header-content", { children: [_jsx("locator-logo", { locale: locale }), _jsx("diamond-button", { variant: "text", width: "square", children: _jsx("button", { type: "button", "data-testid": "about-button", "aria-expanded": open.value, "aria-controls": "locator-layout-main", onClick: () => (open.value = !open.value), children: _jsx("locator-icon", { icon: open.value ? 'close' : 'info', label: t(`about.button.${open.value ? 'close' : 'view'}`), color: "primary" }) }) })] }) }), _jsx("div", { slot: "layout-main", id: "locator-layout-main", children: open.value ? _jsx(About, {}) : children }), _jsx("div", { slot: "layout-aside", className: "display-contents", children: aside ?? _jsx(DefaultAside, {}) })] }));
}
